/**
 * @generated SignedSource<<cbc6df8bdd449a6ad4025c6af10391d7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbRespCreatorDesigns_designPageInfo$data = {
  readonly creatorDesigns: ReadonlyArray<{
    readonly browsePageLinkData: {
      readonly isLinkable: boolean | null;
    };
    readonly url: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"SbSharedCreatorDesignsTile_creatorDesigns">;
  } | null> | null;
  readonly design: {
    readonly displayName: string | null;
  } | null;
  readonly primaryCreator: {
    readonly displayName: string | null;
  } | null;
  readonly " $fragmentType": "SbRespCreatorDesigns_designPageInfo";
};
export type SbRespCreatorDesigns_designPageInfo$key = {
  readonly " $data"?: SbRespCreatorDesigns_designPageInfo$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbRespCreatorDesigns_designPageInfo">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "displayName",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbRespCreatorDesigns_designPageInfo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "IconicDesign",
      "kind": "LinkedField",
      "name": "design",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Creator",
      "kind": "LinkedField",
      "name": "primaryCreator",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "CreatorDesigns",
      "kind": "LinkedField",
      "name": "creatorDesigns",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "browsePageLinkData",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isLinkable",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "SbSharedCreatorDesignsTile_creatorDesigns"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DesignPageInfo",
  "abstractKey": null
};
})();

(node as any).hash = "8d9792e0602f1c2db67bcad0046d1c4c";

export default node;
